import { render } from "./EditTeamMember.vue?vue&type=template&id=137de7f7"
import script from "./EditTeamMember.vue?vue&type=script&lang=js"
export * from "./EditTeamMember.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__